export const MANDATORY_UNIT_COLUMNS: string[] = ['Number', 'Building'];

export const OPTIONAL_UNIT_COLUMNS: string[] = [
  'Status',
  'StrataLot',
  'WarrantyDefaultStartDate',
  'Rooms',
  'Assets',
  'WarrantyAddress',
  'Level',
  'ParkingStalls',
  'StorageLockers',
  'WarrantyNumber',
  'NoOfKeys',
  'KeyAndValues',
  'KeyPickupInstructions',
  'FobNumbers',
  'OrientationDate',
  'CompletionDate',
  'PossessionDate',
];

export const ALL_UNIT_COLUMNS: string[] = [
  ...MANDATORY_UNIT_COLUMNS,
  ...OPTIONAL_UNIT_COLUMNS,
];